import React, { useState } from "react";
import { useParams } from "react-router-dom";
import products from "../data/products";
import ProductCard from "../components/ProductCard";
import "./CategoryPage.css";
import categories from "../data/categories";

const CategoryPage = () => {
  const { name } = useParams();

  // 🔥 FILTER STATES
  const [price, setPrice] = useState(2000);
  const [search, setSearch] = useState("");
  const categoryData = categories[name];

  // 🎯 FILTER LOGIC
  const filteredProducts = products.filter((item) =>
    item.category === name &&
    item.price <= price &&
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="category-page">

      {/* 🔥 BANNER */}
     <div className="category-banner">
  <h1>{categoryData.title} Collection</h1>
  <p>Discover premium handcrafted {categoryData.title}</p>
</div>

      <div className="category-container">

        {/* 🔥 FILTER SIDEBAR */}
        <div className="filters">

          <h3>Filters</h3>

          {/* SEARCH */}
          <input
            type="text"
            placeholder="Search in category..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {/* PRICE */}
          <div className="filter-group">
            <label>Max Price: ₹{price}</label>
            <input
              type="range"
              min="0"
              max="2000"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>

        </div>

        {/* 🔥 PRODUCTS */}
        <div className="products-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((item) => (
              <ProductCard key={item.id} product={item} />
            ))
          ) : (
            <p>No products found</p>
          )}
        </div>

      </div>
    </div>
  );
};

export default CategoryPage;